import { useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import MoneyInput from 'components/Inputs/MoneyInput'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import cashRegisterValidator from 'validators/cashRegisterValidator'
import { Formik } from 'formik'
import { DateTime } from 'luxon'

import {
  Form,
  FormField,
  Label,
  Input,
  Row,
  InfoText,
  WarningText,
  ErrorContainer
} from './styles'

export default function AddCashRegisterModal ({
  visible,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()
  const now = DateTime.now ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Novo caixa</DialogTitle>
        </DialogHeader>
        <Formik
          validationSchema={cashRegisterValidator}
          initialValues={{
            'businessId': businessId,
            'initialCashValue': 0,
            'initialCheckValue': 0,
            'openedAt': `${now.toFormat ('yyyy-MM-dd')}T${now.toFormat ('HH:mm:ss')}`
          }}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const { data: cashRegister } = await cutileiApi.post ('/cash_registers', values, requestConfig)

              setSubmitting (false)
              handleConfirm (cashRegister)
              handleClose ()
            } catch (error) {
              setErrorMessage (getApiErrorMessage (error))
              setSubmitting (false)
              logApiError (error)
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            handleBlur,
            handleSubmit
          }) => {
            return (
              <>
                <DialogBody>
                  <Form onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
                    <Row>
                      <FormField>
                        <Label>Valor inicial (Dinheiro)</Label>
                        <MoneyInput
                          name='initialCashValue'
                          placeholder='Valor inicial (Dinheiro)'
                          value={values.initialCashValue}
                          onValueChange={setFieldValue}
                          onBlur={handleBlur ('initialCashValue')}
                        />
                      </FormField>
                      <FormField>
                        <Label>Valor inicial (Cheque)</Label>
                        <MoneyInput
                          name='initialCheckValue'
                          placeholder='Valor inicial (Cheque)'
                          value={values.initialCheckValue}
                          onValueChange={setFieldValue}
                          onBlur={handleBlur ('initialCheckValue')}
                        />
                      </FormField>
                    </Row>
                    <Row>
                      <FormField>
                        <Label>Data e hora de abertura</Label>
                        <Input 
                          type='datetime-local'
                          placeholder='Data e hora de abertura'
                          value={values.openedAt}
                          disabled={true}
                        />
                        {touched.openedAt && errors.openedAt && (
                          <WarningText>
                            {errors.openedAt}
                          </WarningText>
                        )}
                      </FormField>
                    </Row>
                    {errorMessage && (
                      <ErrorContainer>
                        <InfoText>{errorMessage}</InfoText>
                      </ErrorContainer>
                    )}
                  </Form>
                </DialogBody>
                <DialogFooter>
                  <MainButton
                    label='Abrir caixa'
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    width={140}
                  />
                </DialogFooter>
              </>
            )
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
